import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-completed-action-info',
  templateUrl: './completed-action-info.component.html',
  styleUrls: []
})
export class CompletedActionInfoComponent implements OnInit {

  @Input() leftContent: TemplateRef<any>;
  @Input() data: CompletedActionInfoData;
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onButtonClick(): void {
    this.buttonClick.emit();
  }

}

export interface CompletedActionInfoData {
  title: string;
  buttonLabel: string;
}
